import { createSlice } from '@reduxjs/toolkit';

import asyncThunks from './async-thunks';
import extraReducers from './extra-reducers';
import { ApiState } from './types';

const initialState: ApiState = {
  host: '',
  isError: false,
  isLoading: false,
};

const slice = createSlice({
  extraReducers: (builder) => {
    extraReducers.pauseUnpauseMachineRequest(builder);
  },
  initialState,
  name: 'api',
  reducers: {
    setHost: (state, action) => {
      state.host = action.payload;
    },
  },
});

const api = {
  pauseUnpauseMachineRequest: asyncThunks.pauseUnpauseMachineRequest,
  reducer: slice.reducer,
  setHost: slice.actions.setHost,
};

export default api;
